"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AmountInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      dataTestId = _ref.dataTestId,
      min = _ref.min,
      max = _ref.max,
      className = _ref.className,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      inputAppend = _ref.inputAppend,
      name = _ref.name,
      _ref$roundNumber = _ref.roundNumber,
      roundNumber = _ref$roundNumber === void 0 ? false : _ref$roundNumber,
      _ref$allowChange = _ref.allowChange,
      allowChange = _ref$allowChange === void 0 ? false : _ref$allowChange,
      otherProps = _objectWithoutProperties(_ref, ["value", "disabled", "dataTestId", "min", "max", "className", "onChange", "onBlur", "onFocus", "inputAppend", "name", "roundNumber", "allowChange"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  (0, _react.useEffect)(function () {
    setCurrentValue(value);
  }, [value]);

  var checkValue = function checkValue(value) {
    var parsedValue = parseFloat(value) || 0;

    if (parsedValue >= min && parsedValue <= max) {
      return parsedValue;
    } else {
      if (parsedValue === undefined) {
        return min;
      } else if (parsedValue < min) {
        return min;
      } else if (parsedValue > max) {
        return max;
      }
    }
  };

  var handleChange = function handleChange(value) {
    var isBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var roundedValue = value;
    if (typeof value === 'string' && value !== '' && value !== '-' && value[value.length - 1] !== '.') roundedValue = value.replace(',', '.');
    if (roundNumber && value !== '' && value !== '-') roundedValue = Number(roundedValue).toFixed(0);

    if (!disabled) {
      if (isBlur || allowChange) {
        var checkedValue = roundedValue;
        if (checkedValue !== '' && checkedValue !== '-' && checkedValue[checkedValue.length - 1] !== '.' && checkedValue[checkedValue.length - 1] !== ',') checkedValue = checkValue(roundedValue);
        setCurrentValue(checkedValue);

        if (allowChange && !isBlur) {
          onChange({
            name: name,
            value: checkedValue
          });
        } else {
          onBlur({
            name: name,
            value: checkedValue
          });
        }
      } else {
        setCurrentValue(value);
        onChange({
          name: name,
          value: value
        });
      }
    }
  };

  var handleOnKeyDown = function handleOnKeyDown(_ref2) {
    var keyCode = _ref2.keyCode;

    if (keyCode === 38) {
      //Key: arrow up
      handlePlus();
    } else if (keyCode === 40) {
      //Key: arrow down
      handleMinus();
    }
  };

  var handlePlus = function handlePlus() {
    // Check if number is integer or float
    if (Math.abs(currentValue) % 1 === 0) {
      handleChange(currentValue + 1);
    } else {
      handleChange(Math.ceil(currentValue));
    }
  };

  var handleMinus = function handleMinus() {
    // Check if number is integer or float
    if (Math.abs(currentValue) % 1 === 0) {
      handleChange(currentValue - 1);
    } else {
      handleChange(Math.floor(currentValue));
    }
  };

  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    disabled: disabled,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(InputControls, null, /*#__PURE__*/_react.default.createElement(InputControl, {
    disabled: currentValue == max,
    onClick: currentValue != max ? handlePlus : undefined
  }, /*#__PURE__*/_react.default.createElement(_index.IconActionDropDown, {
    size: 14
  })), /*#__PURE__*/_react.default.createElement(InputControl, {
    disabled: currentValue == min || currentValue === undefined,
    onClick: currentValue != min ? handleMinus : undefined
  }, /*#__PURE__*/_react.default.createElement(_index.IconActionDropDown, {
    size: 14
  }))), /*#__PURE__*/_react.default.createElement(StyledInput, {
    dataTestId: dataTestId,
    name: name,
    type: "text",
    value: currentValue,
    min: min,
    max: max,
    onChange: function onChange(_ref3) {
      var value = _ref3.target.value;
      return handleChange(value);
    },
    onBlur: function onBlur(_ref4) {
      var value = _ref4.target.value;
      return handleChange(value, true);
    },
    disabled: disabled,
    onFocus: onFocus,
    onKeyDown: handleOnKeyDown,
    ref: ref
  }), inputAppend ? /*#__PURE__*/_react.default.createElement(InputExtra, null, inputAppend) : '');
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["width:100%;max-width:100rem;position:relative;border-radius:5px;background-color:", ";box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);overflow:hidden;opacity:", ";font-family:", ";"], function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? '#F0F1F3' : 'white';
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? '0.6' : '1';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
});

var InputControls = _styledComponents.default.div.withConfig({
  displayName: "InputControls"
})(["position:absolute;top:5px;bottom:5px;left:0;width:32px;display:flex;flex-flow:column;justify-content:space-around;align-items:center;"]);

var InputControl = _styledComponents.default.div.withConfig({
  displayName: "InputControl"
})(["cursor:", ";svg path{stroke:#8990a3;opacity:", ";}&:nth-child(1){transform:rotate(180deg);}"], function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled ? '0.2' : '1';
});

var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "StyledInput"
})(["width:calc(100% - 4rem);height:36px;border:0;margin-left:4rem;padding-right:3rem;font-size:1.4rem;background-color:transparent;&:focus{outline:none;box-shadow:0;}"]);

var InputExtra = _styledComponents.default.div.withConfig({
  displayName: "InputExtra"
})(["position:absolute;top:0;right:1rem;bottom:0;font-family:", ";font-weight:500;font-size:1.4rem;line-height:120%;color:", ";display:flex;justify-content:center;align-items:center;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.font;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typo.text;
});

AmountInput.defaultProps = {
  onChange: function onChange() {},
  onBlur: function onBlur() {}
};
AmountInput.propTypes = {
  /** Value of the input (only applied on mount). */
  value: _propTypes.number,

  /** Stops input from working in any way. */
  disabled: _propTypes.bool,
  dataTestId: _propTypes.string,

  /** Minimum value of the input. */
  min: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /** Maximum value of input. */
  max: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /** Extra className to be passed to component. */
  className: _propTypes.string,

  /** Editable string appended to the right of the input. */
  inputAppend: _propTypes.string,

  /** returns onChange event */
  onChange: _propTypes.func,

  /** returns onFocus event */
  onFocus: _propTypes.func,

  /** returns onBlur event */
  onBlur: _propTypes.func,

  /** Other props to be passed to the component. */
  otherProps: _propTypes.object,

  /** Name of the component */
  name: _propTypes.string,

  /** If it should round the number */
  roundNumber: _propTypes.bool,

  /** If this component can change the value (useful for instant input feedback) */
  allowChange: _propTypes.bool
};
AmountInput.displayName = 'AmountInput';
var _default = AmountInput;
exports.default = _default;